<template>
  <v-dialog v-model="showCreateDialog" max-width="490">
    <v-card v-if="welcome">
      <v-card-title class="headline">Neues Verfahren (Nr. {{ max_seq_nr + 1 }}) anlegen</v-card-title>
      <v-card-text>
        Geben Sie einen Namen für das neue Verfahren an.
      </v-card-text>
      <soda-text-field
        class="mx-4"
        ref="first_focus"
        :someModel="process.text_header"
        @input="(someModel) => (process.text_header = someModel)"
        :config="process_specs_dic.text_header"
      >
      </soda-text-field>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="discard()">
          Abbrechen
        </v-btn>
        <v-btn
          v-if="$parent.$vnode.tag.endsWith('ProcessView')"
          color="blue darken-1"
          text
          @click="create_and_new()"
          :disabled="!process.text_header"
        >
          Anlegen und Neu
        </v-btn>
        <v-btn color="blue darken-1" text @click="create()" :disabled="!process.text_header">
          Anlegen
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="saving" class="pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Dokument speichern
    </v-card>
    <v-card v-if="done">
      <v-card-title class="headline">Neues Verfahren angelegt</v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import SodaTextField from "./lib/inputs/SodaTextField";

import load_specs from "../specs/specs_parser";
const process_specs = load_specs("process.yml");

const createProcess = `mutation CreateProcess($input: CreateProcessInput!) {
  createProcess(input: $input) {
    id
  }
}
`;

export default {
  name: "ProcessCreateView",
  components: {
    SodaTextField,
  },
  props: {
    showThis: Boolean,
    company_id: String,
    num_procs: Number,
    max_procs: Number,
  },
  computed: {
    createProcessMutation() {
      return this.$Amplify.graphqlOperation(createProcess, { input: this.process });
    },
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    max_seq_nr: {
      get() {
        return this.$store.state.originalStore.max_seq_nr;
      },
      set(value) {
        this.$store.commit("SET_max_seq_nr", value);
      },
    },
  },
  data: () => ({
    process: {},
    process_specs_dic: Object.assign({}, ...process_specs.fields.map((s) => ({ [s.name]: s }))),
    welcome: true,
    saving: false,
    done: false,
    showCreateDialog: false,
    new_after_create: false,
  }),
  watch: {
    showThis: function(st) {
      this.showCreateDialog = st;
      if (st) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.process = {
        text_header: null,
        seq_nr: this.max_seq_nr + 1,
        processCompanyId: this.company_id,
      };
      this.welcome = true;
      this.saving = false;
      this.done = false;
      this.new_after_create = false;
      this.$nextTick(() => {
        this.$refs.first_focus.focus();
      });
    },
    increment_max_seq_nr() {
      this.max_seq_nr = this.max_seq_nr + 1;
    },
    can_create_process() {
      return this.num_procs < this.max_procs;
    },
    create_and_new() {
      this.new_after_create = true;
      this.create();
    },
    create() {
      if (this.can_create_process()) {
        this.$eventHub.emit("sync-status-syncing");
        this.welcome = false;
        this.saving = true;
        this.$Amplify.API.graphql(this.createProcessMutation)
          .then((response) => this.onCreated(response))
          .catch((err) => {
            this.$eventHub.emit("sync-status-failure", {
              entity_type: "Unternehmen",
              entity_label: this.process.text_header,
              sync_type: "create",
              error: err.errors[0].message,
            });
            this.discard();
          });
      } else {
        this.$eventHub.emit("show-process-create-disallowed", this.num_procs);
      }
    },
    onCreated(response) {
      this.increment_max_seq_nr();
      this.$eventHub.emit("sync-status-success", {
        entity_type: "Verfahren",
        entity_label: this.process.text_header,
        sync_type: "create",
      });
      let process_id = response.data.createProcess.id;
      this.$recordCreate(
        this.company_id,
        "PROCESS",
        {
          id: process_id,
          seq_nr: this.process.seq_nr,
          text_header: this.process.text_header,
        },
        (res, err) => {
          res ? console.log("logged PROCESS create", res) : console.error("error logging PROCESS create", err, e);
        }
      );
      this.$router.push({ path: "/app/company/" + this.company_id + "/process/" + process_id });
      if (this.new_after_create) {
        this.init();
      } else {
        this.saving = false;
        this.done = true;
        this.discard();
      }
    },
    discard() {
      this.$emit("discard");
      this.showCreateDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
